package com.arena_web.data.repository

import com.arena_web.data.api.ActivityApi
import com.arena_web.data.dto.ActivityCountDto
import com.arena_web.data.dto.ActivityDto
import com.arena_web.domain.repositories.ActivityRepository

class ActivityRepositoryImpl(private val activityApi: ActivityApi) : ActivityRepository {

    override suspend fun getActivity(): Result<ActivityDto> =
        apiCall { activityApi.getActivity() }

    override suspend fun getActivityCount(): Result<ActivityCountDto> =
        apiCall { activityApi.getActivityCount() }
}
